<template>
  <LoadingBlock :loading="companyLoading">
    <form @submit.prevent="companySubmit">
      <input type="hidden" name="id" class="form-control" placeholder="" v-model="item_data.id">
      <div class="col mb-4">
        <label class="form-label">Название компании</label>
        <input type="text" name="name" class="form-control" placeholder="" required v-model="item_data.name">
      </div>
      <div class="col mb-4">
        <label class="form-label">База для расчета налогов</label>
        <Select v-model="item_data.tax_type" :options="taxTypes"
                optionLabel="name" optionValue="code" placeholder="" style="width: 100%"/>
      </div>
      <div class="col mb-4">
        <label class="form-label">Процент налога</label>
        <input type="text" name="tax_percent" class="form-control" placeholder="" v-model="item_data.tax_percent">
      </div>
      <div class="col mb-4">
        <label class="form-label">Часовой пояс</label>
        <Select v-model="item_data.timezone" :options="timezones"
                optionLabel="name" optionValue="code" placeholder="Выберите часовой пояс" style="width: 100%" 
                filter/>
      </div>
      <div class="col mb-4 text-center">
        <button type="submit" class="btn btn-primary me-4 waves-effect waves-light">Сохранить</button>
      </div>
    </form>
  </LoadingBlock>
</template>
<script>
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {Message, Messages} from "@/data/messages";
import {Select} from "primevue";
import {updateCompany, updateCompanySettings} from "@/api/company";
import {taxTypes} from "@/data/company"
import {user} from "@/data/user";


export default {
  name: "CompanyForm",
  components: {LoadingBlock, Select},
  data() {
    let timezones = [];
    if (typeof Intl.supportedValuesOf === 'function') {
      timezones = Intl.supportedValuesOf('timeZone');
    }
    return {
      companyLoading: false,
      taxTypes: taxTypes,
      timezones: timezones.map(tz => ({ name: tz, code: tz }))
    }
  },
  computed: {
    item_data() {
      return {...this.item}
    }
  },
  props: {
    item: {
      type: Object
    }
  },
  methods: {
    async companySubmit() {
      this.companyLoading = true
      const message = new Message()
      try {
        const company_id = this.item_data.id
        const results = await Promise.all([
          updateCompany(company_id, {name: this.item_data.name}),
          updateCompanySettings(company_id, {
            tax_type: this.item_data.tax_type,
            tax_percent: this.item_data.tax_percent,
            timezone: this.item_data.timezone,
          }),
        ])
        if (results.every((result) => result.status === 200 || result.status === 201)) {
          message.type = 'success'
          message.autoremove = 10
          message.text = 'Настройки успешно применены'
          if (user.company_info.id === company_id) {
            user.company_info = {...user.company_info, ...this.item_data}
          }
          this.$emit('companySuccess', this.item_data)
        } else {
          message.type = 'failure'
          message.text = 'При создании/обновлении компании произошла ошибка. Проверьте данные, попробуйте снова или обратитесь в поддержку.'
        }
      } catch (e) {
        message.type = 'failure'
        message.text = 'При создании/обновлении компании произошла ошибка. Проверьте данные, попробуйте снова или обратитесь в поддержку.'
      }
      Messages.list.push(message)
      this.companyLoading = false
    }
  },
}
</script>